import type { DayTimes, TimeRange } from "./types";

export function rangeValid(r: TimeRange): boolean {
  return r.endMinute > r.startMinute;
}

export function dayValid(t: DayTimes): boolean {
  return t.anyTime || t.ranges.some(rangeValid);
}
